import React from 'react';
import { Link } from 'react-router-dom'

import Banner from '../App/Banner'

import Check from '../../assets/check.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function FranceToUE() {
  return(
    <div>
      <Banner />
      <div id="france" className='paper'>

      <Link to='/France'>
          <button className="return">
          <img src={GreyArrow} alt="fleche grise"/>
            Retour
          </button>
        </Link>

        <div className='breadcrumbs'>
          <p><img src={Check} />Votre stock se situe en France</p>
          <p><img src={Check} />Vous vendez vers l'Union Européenne</p>
        </div>

      <div id="FranceToUE" className='paper'>
        <h4>Votre chiffre d'affaires :</h4>
        <p style={{marginBottom:'2em', fontWeight:'400'}}>Prévoyez-vous de faire <span style={{fontWeight: '600'}} >plus de 10 000 €</span> de chiffre d’affaires en UE sur l’année civile en cours ?
        <br /><span style={{color:'#11ABEC'}}>ou</span><br />
        Avez-vous fait <span style={{fontWeight: '600'}}>plus de 10 000 €</span> de chiffre d’affaires en UE sur l’année civile précédente ?</p>
        
          <div className="select_container">
            <Link to='/OSS'><button className="select">Oui</button></Link>
            <Link to='/FranceToUELessThan10K'><button className="select">Non</button></Link>
          </div>
        
      </div>
      </div>
    </div>
  )
}

export default FranceToUE